// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._container[data-v-13953cb8] {\n  display: grid;\n  grid-template-columns: min-content auto;\n  align-items: center;\n}", ""]);
// Exports
module.exports = exports;
